import React, { Fragment, useState } from 'react';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { H5 } from '../../../../AbstractElements';
import Commen from './Commen';
const MouseDisabled = () => {
  const [val, setVal] = useState(10);
  return (
    <Fragment>
      <Col sm='12' md='6'>
        <Card>
          <CardHeader className='pb-0'>
            <H5 className='card-title'>{'Touchspin mousewheel Disable'}</H5>
            <span>
              {'Add'} <code>{'..touchspin-stop-mousewheel'}</code>
              {' class to diable mousewheel.'}
            </span>
          </CardHeader>
          <CardBody>
            <Commen val={val} setVal={setVal} />
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default MouseDisabled;
